/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  function parseMaxDuration(value) {
    return Math.max(
      ...String(value || "0s")
        .split(",")
        .map((part) => {
          const token = part.trim();

          if (!token) {
            return 0;
          }

          const amount = parseFloat(token);

          if (!Number.isFinite(amount)) {
            return 0;
          }

          return token.endsWith("ms") ? amount : amount * 1000;
        })
    );
  }

  function patchWaitForAnimationEnd() {
    if (!window.theme) {
      return false;
    }

    window.theme.waitForAnimationEnd = function waitForAnimationEnd(element) {
      return new Promise((resolve) => {
        if (!element) {
          resolve();
          return;
        }

        const styles = window.getComputedStyle(element);
        const totalDuration = Math.max(
          parseMaxDuration(styles.animationDuration) + parseMaxDuration(styles.animationDelay),
          parseMaxDuration(styles.transitionDuration) + parseMaxDuration(styles.transitionDelay)
        );

        let settled = false;
        let timeoutId = 0;

        function finish() {
          if (settled) {
            return;
          }

          settled = true;
          element.removeEventListener("animationend", onAnimationEnd);

          if (timeoutId) {
            window.clearTimeout(timeoutId);
          }

          resolve();
        }

        function onAnimationEnd(event) {
          if (event.target === element) {
            finish();
          }
        }

        element.addEventListener("animationend", onAnimationEnd);

        if (totalDuration > 0) {
          timeoutId = window.setTimeout(finish, Math.ceil(totalDuration) + 50);
        } else {
          window.requestAnimationFrame(finish);
        }
      });
    };

    return true;
  }

  if (!patchWaitForAnimationEnd()) {
    window.addEventListener("DOMContentLoaded", patchWaitForAnimationEnd, { once: true });
  }
})();

(function () {
  const POPUP_TAG_NAME = "popup-newsletter";
  const HIDDEN_CLOSE_SELECTOR = 'form[method="dialog"] .visually-hidden';
  const IS_IOS =
    /iPad|iPhone|iPod/.test(window.navigator.userAgent) ||
    (window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);

  function disableHiddenCloseButton(popup) {
    const hiddenCloseButton = popup.querySelector(HIDDEN_CLOSE_SELECTOR);

    if (!(hiddenCloseButton instanceof HTMLButtonElement) || hiddenCloseButton.__otroPatched) {
      return;
    }

    hiddenCloseButton.disabled = true;
    hiddenCloseButton.tabIndex = -1;
    hiddenCloseButton.setAttribute("aria-hidden", "true");
    hiddenCloseButton.__otroPatched = true;
  }

  function patchNewsletterPopup() {
    const PopupNewsletter = window.customElements.get(POPUP_TAG_NAME);

    if (!PopupNewsletter) {
      return false;
    }

    if (PopupNewsletter.prototype.__otroIOSPopupPatched) {
      return true;
    }

    PopupNewsletter.prototype.popupOpen = function popupOpenPatched() {
      disableHiddenCloseButton(this.popup);
      if (!IS_IOS) {
        this.isAnimating = true;

        if (typeof this.popup.showModal !== "function" || this.preventTopLayer) {
          if (typeof this.popup.show === "function") {
            this.popup.show();
          } else {
            this.popup.setAttribute("open", "");
          }
        } else {
          this.popup.showModal();
        }

        this.popup.removeAttribute("inert");
        this.popup.setAttribute("aria-hidden", "false");
        this.popup.focus();

        if (this.enableScrollLock) {
          document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));
        }

        window.theme.waitForAnimationEnd(this.popup).then(() => {
          this.isAnimating = false;
          if (this.enableScrollLock) {
            this.a11y.trapFocus(this.popup);
          }
        });
        return;
      }

      this.isAnimating = true;

      if (typeof this.popup.showModal !== "function" || this.preventTopLayer) {
        if (typeof this.popup.show === "function") {
          this.popup.show();
        } else {
          this.popup.setAttribute("open", "");
        }
      } else {
        this.popup.showModal();
      }

      this.popup.removeAttribute("inert");
      this.popup.setAttribute("aria-hidden", "false");

      if (this.enableScrollLock) {
        document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));
      }

      window.theme.waitForAnimationEnd(this.popup).then(() => {
        this.isAnimating = false;
      });
    };

    PopupNewsletter.prototype.__otroIOSPopupPatched = true;
    return true;
  }

  if (!patchNewsletterPopup()) {
    if (window.customElements && typeof window.customElements.whenDefined === "function") {
      window.customElements.whenDefined(POPUP_TAG_NAME).then(patchNewsletterPopup);
    } else {
      window.addEventListener("DOMContentLoaded", patchNewsletterPopup, { once: true });
    }
  }
})();